<template>
  <div class="image-container" :style="style">
    <div class="image-preview">
      <img
        v-if="isWeb"
        :src="imageUrl"
        :style="imageStyle"
        :alt="widget.position.name"
        @error="handleImageError"
      />
      <template v-else>
        <img
          v-if="!isImageLoadError"
          :src="imageUrl"
          :style="imageStyle"
          :alt="widget.position.name"
          @error="handleImageError"
        />
        <img
          v-else
          :src="defaultImageUrl"
          :style="imageStyle"
          :alt="widget.position.name"
          @error="handleDefaultImageError"
        />
      </template>
    </div>
  </div>
</template>

<script>
  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import { getItemLocalUrl, getItemUrl } from '@/utils/mediaAsset';
  import { logger } from '@/utils/screenEventsLogger';

  export default {
    name: 'ImageWidget',

    mixins: [templateWidget, simpleTypeMixin],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    data() {
      return { isImageLoadError: false };
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          opacity: this.widget.position.isHidden ? 0 : Number(this.widget.position.opacity) / 100,
          position: 'absolute',
        });
      },

      imageMode() {
        return this.widget.position.imageMode || 'cover';
      },

      cropData() {
        return (
          this.widget.position.cropData || {
            left: 0,
            top: 0,
            width: 100,
            height: 100,
          }
        );
      },

      imageStyle() {
        const baseStyle = {
          objectFit: this.widget.position.imageMode,
        };

        if (this.cropData) {
          const cropData = this.cropData;
          const scaleX = 100 / cropData.width;
          const scaleY = 100 / cropData.height;
          const translateX = -cropData.left * scaleX;
          const translateY = -cropData.top * scaleY;

          return Object.assign({}, baseStyle, {
            transform:
              'translate(' +
              translateX +
              '%, ' +
              translateY +
              '%) scale(' +
              scaleX +
              ', ' +
              scaleY +
              ')',
            transformOrigin: 'top left',
            width: '100%',
            height: '100%',
          });
        }

        return baseStyle;
      },

      isWeb() {
        return window.isWeb;
      },

      imageUrl() {
        return getItemLocalUrl(this.widget.object.item_url, this.widget.object.item_id);
      },

      defaultImageUrl() {
        return getItemUrl(this.widget.object.item_url);
      },
    },

    methods: {
      handleImageError() {
        this.isImageLoadError = true;
        logger.addLog(`Failed to load image: ${this.imageUrl}`);
      },

      handleDefaultImageError() {
        logger.addLog(`Failed to load default image: ${this.defaultImageUrl}`);
      },

      showImage() {
        //this.$emit('show-enlarged', this.widget)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .image-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .image-preview {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
